import { notification } from 'ant-design-vue';

import {
  useFileContentServiceCreateMutation as useSyncMutation,
  useFileContentServiceAsyncCreateMutation as useAsyncMutation,
} from '@/graphql/generated/graphql';

const useFileContentServiceCreateMutation = () => {
  const { fetching, executeMutation, error } = useSyncMutation();
  const { fetching: asyncFetching, executeMutation: executeAsyncMutation, error: asyncError } = useAsyncMutation();

  const runCreate = async (fileId: number) => {
    const response = await executeMutation({ file_id: fileId });
    if (response.data?.fileContentServiceCreate) {
      notification.success({
        message: 'File content created. It will be available in a few seconds.',
        description: `Row id ${response.data.fileContentServiceCreate.id}`,
      });
    }
  };

  const runCreateAsync = async (fileId: number) => {
    const response = await executeAsyncMutation({ file_id: fileId });
    if (response.data?.fileContentServiceAsyncCreate) {
      notification.success({
        message: 'File content created. It will be available when the job is completed.',
        description: `Row id ${response.data.fileContentServiceAsyncCreate.id}`,
      });
    }
  };

  return {
    fetching: computed(() => fetching.value || asyncFetching.value),
    error: computed(() => error.value || asyncError.value),
    runCreate,
    runCreateAsync,
  };
};

export default useFileContentServiceCreateMutation;